import { render } from "./Step4LearnMore.vue?vue&type=template&id=271c527c"
import script from "./Step4LearnMore.vue?vue&type=script&lang=js"
export * from "./Step4LearnMore.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__